import Vue from 'vue';
// import VueAwesomeSwiper from 'vue-awesome-swiper';

if (process.browser) {
    // const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
    const VueAwesomeSwiper = require('vue-awesome-swiper/dist/vue-awesome-swiper');
    Vue.use(VueAwesomeSwiper);
}
